var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBackgroundMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 52,
    viewBox: "0 0 156 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_167_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1042 41.5547L19 36.2829L19 12.2669L40.1042 6.99514L151.478 6.99513L151.478 41.5547L40.1042 41.5547Z",
    fill: "#FFD8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.613 43.5209L39.8549 43.5813L40.1042 43.5813L151.478 43.5813L153.505 43.5813L153.505 41.5547L153.505 6.99513L153.505 4.96852L151.478 4.96852L40.1042 4.96852L39.8549 4.96852L39.613 5.02894L18.5088 10.3007L16.9734 10.6843L16.9734 12.2669L16.9734 36.2829L16.9734 37.8655L18.5088 38.2491L39.613 43.5209Z",
    stroke: "white",
    strokeWidth: 4.05323
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_167_667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5396,
    cy: 23.4447,
    rx: 6.58651,
    ry: 6.5865,
    transform: "rotate(-90 38.5396 23.4447)",
    fill: "#C3BFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_167_667",
    x: 0.759968,
    y: 0.915277,
    width: 154.771,
    height: 50.7725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10.1331,
    dy: 2.02662
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_167_667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_167_667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_167_667",
    x: 31.9531,
    y: 16.8584,
    width: 13.1729,
    height: 17.2261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.05323
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_167_667"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBackgroundMobile);
export default __webpack_public_path__ + "static/media/menuBackgroundMobile.956d3c82fbfe3d614689444552b2df6b.svg";
export { ForwardRef as ReactComponent };